import { Children, useEffect, useState } from "react";
import { formatString } from "@format-string/core";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import {
  ModalDeleteCore,
  TableRowCore,
  TableCore,
  TdCore,
} from "src/Pages/components";
import { handleChipCoreCategories } from "src/Pages/components/CategoryComponentMap";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  DeleteForeverIcon,
  PersonOffIcon,
  Visibility,
  PersonIcon,
  CheckIcon,
  CloseIcon,
  EditIcon,
  GroupIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { ModalChangeFunctionProducer } from "../ChangeFunction";
import { ModalChangeIsActiveProducer } from "../ChangeIsActiveProducer/ModalChangeIsActiveproducer";
import { FilterSidebarProdutor } from "../FilterSidebar/FilterSidebar";
import { ModalChangeAccessProducer } from "../ModalChangeAccessProducer/ModalChangeAccessProducer";

import { UseGetByIdProducer } from "./hooks/UseGetByIdProducer";
import { useHttpTableProdutor } from "./hooks/useHttpTableProdutor";
import { THeadProducer } from "./THead";
import { ModalFormProducer } from "../FormProducer";
import { ChipCore } from "src/Pages/components/ChipCore/ChipCore";
import { objColorsChipsFunctionProducer } from "src/shared/ColorObj/ColorsChipsFunctionProducer";
import { CardsMetricsProducer } from "./CardsMetricsProducer";
import {
  QuickFiltersProducer,
  TQuickProducerFilterId,
} from "./QuickFiltersProducer";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";

interface IChangeAccess {
  idTenant: string;
  email: string;
  isActiveAccess: boolean;
}

export const TableProdutores = () => {
  const navigate = useNavigate();

  const {
    listProdutor,
    valuesFilterProducer,
    setValuesFilterProducer,
    metricsProducer,
  } = useContextProdutor();
  const { handleGet } = useHttpTableProdutor();
  const { handleGetById } = UseGetByIdProducer();
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();

  const {
    setActive_incluir,
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();
  const [openModalChangeFunction, setOpenModalChangeFunction] = useState(false);

  const [dataProdutorToEditFunction, setDataProdutorToEditFunction] = useState({
    name: "",
    function: "CORRETOR",
  });

  const [openModalComissao, setOpenModalComissao] = useState(false);
  const [openModalIsActiveProducer, setOpenModalIsActiveProducer] =
    useState(false);

  const [valueIsActiveProducer, setValueIsActiveProducer] =
    useState<boolean>(true);

  const [valueChangeAccessProducer, setValueChangeAccessProducer] =
    useState<IChangeAccess>({ email: "", idTenant: "", isActiveAccess: false });

  const [openModalFormProducer, setOpenModalFormProducer] = useState(false);
  const activeQuickFilter =
    valuesFilterProducer.functionProducer === "ALL"
      ? undefined
      : (valuesFilterProducer.functionProducer as TQuickProducerFilterId);

  const executeFilterSearch = (functionProducer: "ALL" | TQuickProducerFilterId) => {
    const newFilters = {
      ...valuesFilterProducer,
      functionProducer,
    };

    setValuesFilterProducer(newFilters);
    handleGet({
      codProducer: newFilters.codProducer,
      nomeProducer: newFilters.nomeProducer,
      cpfProducer: newFilters.cpfProducer,
      isActiveProducer: newFilters.isActiveProducer,
      functionProducer: newFilters.functionProducer,
    });
  };

  const handleQuickFilterToggle = (filterId: TQuickProducerFilterId) => {
    const nextFunctionProducer =
      valuesFilterProducer.functionProducer === filterId ? "ALL" : filterId;

    executeFilterSearch(nextFunctionProducer);
  };

  const handleClearQuickFilters = () => {
    executeFilterSearch("ALL");
  };

  const handleGetIdToEdit = (id: string) => {
    setId(id);
    setOpenModalFormProducer(true);
    handleGetById(id);
  };

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/produtor" });

  useEffect(() => {
    handleGet({
      currentPage,
      itensPerPage,
      nameSearch,
      isActiveProducer: valuesFilterProducer.isActiveProducer,
      codProducer: valuesFilterProducer.codProducer,
      nomeProducer: valuesFilterProducer.nomeProducer,
      cpfProducer: valuesFilterProducer.cpfProducer,
      functionProducer: valuesFilterProducer.functionProducer,
    });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  return (
    <TableCore
      Modals={
        <>
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />

          <ModalChangeAccessProducer
            data={valueChangeAccessProducer}
            modalComissao={openModalComissao}
            setModalComissao={setOpenModalComissao}
          />

          <ModalChangeFunctionProducer
            dataProdutorToEditFunction={dataProdutorToEditFunction}
            openModal={openModalChangeFunction}
            setDataProdutorToEditFunction={setDataProdutorToEditFunction}
            setOpenModal={setOpenModalChangeFunction}
          />

          <ModalChangeIsActiveProducer
            isActiveProducer={valueIsActiveProducer}
            modalIsActiveProducer={openModalIsActiveProducer}
            setModalIsActiveProducer={setOpenModalIsActiveProducer}
          />
        </>
      }
      THead={<THeadProducer />}
      filter={<FilterSidebarProdutor />}
      qtdList={listProdutor.length}
      setNameSearch={setNameSearch}
      metrics={
        <Box>
          <CardsMetricsProducer
            metrics={{
              corretor: metricsProducer.corretor,
              supervisor: metricsProducer.supervisor,
              gerente: metricsProducer.gerente,
              total: metricsProducer.total_producers,
            }}
          />
          <Box sx={{ marginTop: "16px" }}>
            <QuickFiltersProducer
              activeFilter={activeQuickFilter}
              onFilterToggle={handleQuickFilterToggle}
              onClearFilters={handleClearQuickFilters}
            />
          </Box>
        </Box>
      }
      cardAdd={{
        title: "Produtores",
        icon: <GroupIcon color="primary" />,
        subTitle: "Gerencie sua equipe de vendas.",
        buttonAdd: [
          <ModalFormProducer
            key={1}
            openModal={openModalFormProducer}
            setOpenModal={setOpenModalFormProducer}
          />,
        ],
      }}
    >
      {Children.toArray(
        listProdutor.map((item) => {
          return (
            <TableRowCore id={item.id_tenant}>
              <TdCore
                values={
                  <ActionPopoverTable
                    key={item.id_tenant}
                    optionsList={[
                      {
                        icon: <Visibility fontSize="small" />,
                        title: "Ver produtor",
                        background: "success",
                        onClick: () => {
                          navigate(`/Produtores/produtor/${item.id_tenant}`);
                        },
                      },
                      {
                        icon: <Visibility fontSize="small" />,
                        title: "Acesso online",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.PRODUCER.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.id_tenant);
                          setOpenModalComissao(true);
                          setValueChangeAccessProducer({
                            email: item.email,
                            idTenant: item.id_tenant,
                            isActiveAccess: item.is_active_access_producer,
                          });
                        },
                      },
                      {
                        title: !item.is_active_producer
                          ? "Ativar produtor"
                          : "Desativar produtor",
                        background: "warning",
                        icon: item.is_active_producer ? (
                          <PersonOffIcon fontSize="small" />
                        ) : (
                          <PersonIcon fontSize="small" />
                        ),
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.PRODUCER.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.id_tenant);
                          setOpenModalIsActiveProducer(true);
                          setValueIsActiveProducer(!item.is_active_producer);
                        },
                      },
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Trocar função",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.PRODUCER.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.id_tenant);
                          setOpenModalChangeFunction(true);
                          setDataProdutorToEditFunction({
                            function: item.funcao_produtor,
                            name: item.nome,
                          });
                        },
                      },
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.PRODUCER.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.id_tenant);
                          handleGetIdToEdit(item.id_tenant);
                          setActive_incluir(true);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.PRODUCER.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.id_tenant);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore
                textAlign="center"
                values={
                  <IconButton
                    onClick={() => navigate(`/Produtores/produtor/${item.id_tenant}`)}
                  >
                    <Visibility fontSize="small" sx={{ color: "#A6A6A6FF" }} />
                  </IconButton>
                }
              />
              <TdCore
                isAvatar
                isLimit
                isLimitQTD={30}
                subTitle={
                  item.fisico_juridico === "juridica"
                    ? formatString({ value: item?.cpf_cnpj, type: "cnpj" })
                    : formatString({ value: item?.cpf_cnpj, type: "cpf" })
                }
                sxStyle={{ fontWeight: "600", padding: "4px 0", fontSize: "12.8px" }}
                titleAvatar={item.nome}
                values={`${item.id}-${item.nome}`}
              />

              <TdCore
                textAlign="center"
                values={
                  <ChipCore
                    colorCore={objColorsChipsFunctionProducer[item.funcao_produtor].color}
                    label={objColorsChipsFunctionProducer[item.funcao_produtor].label}
                    icon={objColorsChipsFunctionProducer[item.funcao_produtor].icon}
                    sxStyle={{ width: "110px" }}
                  />
                }
              />
              <TdCore
                textAlign="center"
                values={handleChipCoreCategories(item.tipo_produtor)}

              />

              <TdCore
                isLimit
                isLimitQTD={30}
                values={`${item.supervisor.id}-${handleIfLimitCharacter({ value: item.supervisor.nome, LIMIT: 16 })}`}
                tooltip={item.supervisor.nome}

              />
              <TdCore
                isLimit
                isLimitQTD={30}
                values={`${item.gerente.id}-${handleIfLimitCharacter({ value: item.gerente.nome, LIMIT: 16 })}`}
                tooltip={item.gerente.nome}
              />

              <TdCore values={item.filial.nome} />

              <TdCore
                color={item.contaCorrente.saldo < 0 ? "red" : "#3cb916"}
                values={`R$ ${item.contaCorrente.saldo < 0 ? "-" : ""} ${FormatMoney(String(item.contaCorrente.saldo))}`}
              />
              <TdCore values={handleChipCoreCategories(item.grupoImposto.nome)} />

              <TdCore
                textAlign="center"
                values={
                  <ChipCore
                    colorCore={item.is_active_producer ? "#069A35FF" : "#EF4444"}
                    label={item.is_active_producer ? "Ativo" : "Inativo"}
                    sxStyle={{ width: "60px", border: "none" }}
                  />
                }
              />

              <TdCore
                textAlign="center"
                values={
                  item.is_active_access_producer
                    ? (<CheckIcon color="success" sx={{ fontSize: "18px" }} />)
                    : (<CloseIcon color="error" sx={{ fontSize: "18px" }} />)
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
